import { useCallback } from 'react';
import type { EntityDataObject } from 'models/service';

export const useRequestMentions = (onRequestMentions: (value: string) => Promise<EntityDataObject[]>) =>
  useCallback(
    async (value: string) => {
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
      if (value && onRequestMentions) {
        const data = await onRequestMentions(value);
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
        if (data) {
          return data.map((user) => ({
            id: `@${user.name}`,
            link: `/members/${user.id}`,
            userId: user.id,
          }));
        }
      }

      return [];
    },
    [onRequestMentions],
  );
